module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/link-arrow-dark-280ec2734a0419adb5b1bd53cc0fdf89.svg";